<template>
  <div>
    <modal-crear-editar
      :configuracion="configuracion_modal"
      @realizado="restablecer_inputs"
    ></modal-crear-editar>
    <tablita
      @cargar="cargar($event)"
      @cargar_url="cargar_url($event)"
      @nuevo="crear"
      @editarmenus="editarmenus($event)"
      @editarpermisos="editarpermisos($event)"
      @editar="editar($event)"
      :configuracion="configuracion_tabla"
      @refresh="refrescar($event)"
      :cols="columnas"
    ></tablita>

    <!-- Modal permisos -->
    <div
      class="modal fade"
      id="modal_permisos"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        :class="`modal-dialog modal-dialog-centered modal-lg`"
        role="document"
        style="width: 80%"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              PERMISOS DEL ROL "{{ `${item ? item.name : ""}` }}"
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col fixTableHead">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th class="text-center">Id</th>
                      <th class="text-center">Nombre</th>
                      <th class="text-center">Guard</th>
                      <th class="text-center">Asignar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(p, idx) in permisos" :key="idx">
                      <td>{{ p.id }}</td>
                      <td>{{ p.name }}</td>
                      <td>{{ p.guard_name }}</td>
                      <td>
                        <input
                          type="checkbox"
                          name=""
                          id=""
                          :value="p.id"
                          v-model="p.check"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- <pre>{{menus_ids}}</pre> -->
            <!-- <pre>{{menus}}</pre> -->
          </div>
          <div class="modal-footer">
            <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
            <button
              type="button"
              @click="guardar_permisos"
              :class="`btn btn-primary`"
            >
              GUARDAR
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal permisos -->

    <!-- Modal menus -->
    <div
      class="modal fade"
      id="modal_menus"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        :class="`modal-dialog modal-dialog-centered modal-lg`"
        role="document"
        style="width: 80%"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              MENUS DEL ROL "{{ `${item ? item.name : ""}` }}"
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <!-- <div class="form-group">
                    <label for="form-control-label">Menus</label>
                    <v-select class="" :reduce="option => option.id" v-model="menus_ids" :options="menus" label="texto" multiple>
                        <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                            No se Encontraron Resultados Para <em>{{ search }}</em>.
                        </template>
                        <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                        </template>
                    </v-select>
                </div> -->

            <div class="row">
              <div class="col fixTableHead">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th class="text-center">Id</th>
                      <th class="text-center">Sistema</th>
                      <th class="text-center">Debajo de</th>
                      <th class="text-center">Menu</th>
                      <th class="text-center">Asignar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(m, idx) in menus" :key="idx">
                      <td>{{ m.id }}</td>
                      <td>{{ m.sistema }}</td>
                      <td>{{ m.debajo_de_texto }}</td>
                      <td>{{ m.texto }}</td>
                      <td>
                        <input
                          type="checkbox"
                          name=""
                          id=""
                          :value="m.id"
                          v-model="m.check"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- <pre>{{menus_ids}}</pre> -->
            <!-- <pre>{{menus}}</pre> -->
          </div>
          <div class="modal-footer">
            <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
            <button
              type="button"
              @click="guardar_menus"
              :class="`btn btn-primary`"
            >
              GUARDAR
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal menus -->
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCrearEditar from "../../components/Modal/ModalEditarCrear";
import Swal from "sweetalert2";
import Tabla from "../../components/Tabla/Tabla";
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    filter: "",
    columnas: [
      {
        key: "name",
        label: "Nombre",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "name",
      },
      {
        key: "guard_name",
        label: "Guard",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "guard_name",
      },
      {
        key: "sistema",
        label: "Sistema",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "sistema",
      },
    ],
    botones: [
      {
        label: "Editar",
        clase: "btn-warning",
        evento: "editar",
        icono: "fa fa-pen",
      },
      {
        label: "Menus",
        clase: "btn-primary",
        evento: "editarmenus",
        icono: "fa fa-users",
      },
      {
        label: "Permisos",
        clase: "btn-info",
        evento: "editarpermisos",
        icono: "fa fa-cog",
      },
    ],
    lista: [],
    links: [],
    inputs: [
      {
        cols: 4,
        tipo: "texto",
        key: "name",
        valor: "",
        label: "Nombre (*)",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "sistema",
        valor: "",
        label: "Sistema",
        disabled: false,
      },
      {
        cols: 4,
        tipo: "texto",
        key: "guard_name",
        valor: "",
        label: "Guard (*)",
        disabled: false,
      },
    ],
    configuracion_modal: {
      titulo: "Registrar Rol",
      ancho: "lg",
      ruta: "/roles",
      tipo_ruta: "post",
      titulo_boton: "Crear",
      clase_boton: "btn-success",
    },
    configuracion_tabla: {
      titulo: "Listado de Roles",
      titulo_boton: "Crear Rol",
      clase_boton: "btn-primary",
      btn_nuevo: true,
    },
    pagina_actual: "",
    item: null,
    permisos_ids: [],
    permisos: [],
    menus: [],
    menus_ids: [],
  }),
  mounted() {
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });
    let storage = localStorage.getItem(this.path);
    if (storage) {
      storage = JSON.parse(storage);
      this.columnas.forEach((col) => {
        col.busqueda = storage.columnas.find((c) => c.key == col.key).val;
      });
    }
    this.cargar_menus();
  },
  methods: {
    refrescar() {
      localStorage.removeItem(this.path);
      this.columnas.forEach((c) => {
        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });
      this.$emit("cargar");
    },
    async cargar_menus() {
      await this.axios
        .get(`${this.api}/menus?limit=99999`, this.cabeceras_json)
        .then((res) => {
          this.menus = res.data.data.data;
          this.resetear_menus();
          ////console.log('menus',this.menus);
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_permisos();
    },

    resetear_menus() {
      this.menus.forEach((m) => {
        m.check = false;
      });
    },

    setear_menus() {
      this.menus.forEach((m) => {
        let check = this.menus_ids.findIndex((id) => m.id == id);
        if (check != -1) {
          m.check = true;
        }
      });
    },

    resetear_permisos() {
      this.permisos.forEach((p) => {
        p.check = false;
      });
    },

    setear_permisos() {
      this.permisos.forEach((p) => {
        let check = this.permisos_ids.findIndex((id) => p.id == id);
        if (check != -1) {
          p.check = true;
        }
      });
    },

    async cargar_permisos() {
      await this.axios
        .get(`${this.api}/permissions?limit=99999`, this.cabeceras_json)
        .then((res) => {
          this.permisos = res.data.data.data;
          //console.log('permisos',this.permisos);
        })
        .catch((e) => {
          //console.log(e);
        });
      //this.cargar("");
      this.$emit("cargar");
    },

    async cargar($event) {
      this.pagina_actual = `${this.api}/roles${$event}`;
      this.lista = [];
      await this.axios
        .get(`${this.api}/roles${$event}`, this.cabeceras_json)
        .then((res) => {
          this.lista = res.data.data.data;
          this.links = res.data.data.links;
          /* let config = {
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links
                } */
          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
          });
          this.$emit("generar", this.columnas, this.lista);
          ////console.log('listado',res.data.data.data);
          //$('#empresas').DataTable().draw();
        })
        .catch((e) => {
          //alert(e);
        });
    },
    async cargar_url(url) {
      if (url) {
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then((res) => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            ////console.log('listado',res.data.data.data);
            this.setear_lista({ lista: this.lista, links: this.links });
            //$('#empresas').DataTable().draw();
          })
          .catch((e) => {
            //alert(e);
          });
      }
    },
    crear() {
      this.setear_inputs(this.inputs);
      this.restablecer_inputs();
      this.configuracion_modal.ruta = `/roles`;
      this.configuracion_modal.tipo_ruta = "post";
      this.configuracion_modal.titulo_boton = "Crear";
      this.configuracion_modal.clase_boton = "btn-success";

      this.$emit("abrir", { inputs: this.inputs });
    },
    editar(evento) {
      //console.log('evento',evento);
      let item = evento.item;
      this.inputs.forEach((i) => {
        //recorrido del objeto a editar
        Object.keys(item).forEach((key) => {
          let valor = item[key];
          if (i.key == key) {
            i.valor = valor;
          }
        });
      });

      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/roles/${evento.item.id}`;
      this.configuracion_modal.tipo_ruta = "put";
      this.configuracion_modal.titulo_boton = "Actualizar";
      this.configuracion_modal.clase_boton = "btn-warning";

      this.$emit("abrir");
    },

    async editarpermisos(event) {
      await this.resetear_permisos();
      this.item = event.item;
      //console.log('item',this.item);
      this.permisos_ids = this.item.permissions_ids;
      await this.setear_permisos();
      $("#modal_permisos").modal({ show: true });
    },

    async editarmenus(event) {
      await this.resetear_menus();
      this.item = event.item;
      //console.log('item',this.item);
      this.menus_ids = this.item.menus_ids;
      await this.setear_menus();
      $("#modal_menus").modal({ show: true });
    },

    async guardar_permisos() {
      let body = {
        permissions_ids: this.permisos
          .filter((p) => p.check == true)
          .map((p) => p.id),
      };
      await this.axios
        .post(
          `${this.api}/roles/${this.item.id}/guardar_permisos`,
          body,
          this.cabeceras_json
        )
        .then((res) => {
          //console.log('respuesta',res.data);
          Swal.fire({
            icon: "success",
            title: res.data.mensaje,
            confirmButtonColor: "#2dce89"
          });
          this.cargar("");
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    async guardar_menus() {
      let body = {
        menus_ids: this.menus.filter((m) => m.check == true).map((m) => m.id),
      };
      await this.axios
        .post(
          `${this.api}/menus/${this.item.id}/guardar_menus`,
          body,
          this.cabeceras_json
        )
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: res.data.mensaje,
            confirmButtonColor: "#2dce89"
          });
          //console.log('respuesta',res.data);
          this.cargar("");
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    restablecer_inputs() {
      this.cargar_url(this.pagina_actual);
      this.inputs.forEach((i) => {
        i.valor = "";
      });
      this.setear_inputs(this.inputs);
    },
    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"]),
  },
  components: {
    "modal-crear-editar": ModalCrearEditar,
    tablita: Tabla,
  },
  computed: {
    ...mapState(["api", "cabeceras_json"]),
    query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }

        if (c.busqueda != "") {
          string += `${and}${c.key}=${c.busqueda}`;
        }
      });
      return string;
    },
    path() {
      return this.$router.currentRoute.path;
    },
  },
};
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>